import { Component, Inject, OnInit, Optional } from '@angular/core';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { FormControl, Validators } from '@angular/forms';
import { Client } from '../../../../components/client/classes/client';
import { Freigabe } from './../freigabe';
import { KieneBackendApiService } from '../../../../services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../services/message-service/message.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpParams } from '@angular/common/http';

export interface FreigabeDialogData {
    freigabe?: Freigabe;
}

@Component({
    selector: 'kiene-freigabe-erstellen-dialog',
    templateUrl: './freigabe-erstellen-dialog.component.html',
    styleUrls: ['./freigabe-erstellen-dialog.component.scss'],
})
export class FreigabeErstellenDialogComponent implements OnInit {
    vvvoCtrl = new FormControl(undefined, [Validators.required, Validators.minLength(12), Validators.maxLength(15)]);

    sourceClientParams = new HttpParams().set('freigaben', '0');
    recipientParams = new HttpParams();
    betriebDisplayFields = ['bezeichnung_final', 'zusatz_final', 'vvvo'];

    kunde: Client;
    editFreigabe: Freigabe;
    modulBelege = false;
    modulTierbewegung = true;
    modulBio = false;

    constructor(
        @Inject(API_BASE_URL_SERVICE) public apiBaseUrl: string,
        public dialogRef: MatDialogRef<FreigabeErstellenDialogComponent>,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: FreigabeDialogData,
    ) {}

    ngOnInit(): void {
        if (this.data?.freigabe?.kf_id) {
            this.editFreigabe = this.data.freigabe;
            this.modulBelege = Number(this.editFreigabe.modul_belege) !== 0;
            this.modulTierbewegung = Number(this.editFreigabe.modul_tierbewegung) !== 0;
            this.modulBio = Number(this.editFreigabe.modul_bio) !== 0;
        }
    }

    get isEdit(): boolean {
        return Number(this.editFreigabe?.kf_id) > 0;
    }

    setClient(client: Client) {
        this.kunde = client;
    }

    setRecipient(client: Client) {
        const vvvo = client?.vvvo ? String(client.vvvo).trim() : '';
        this.vvvoCtrl.setValue(vvvo || undefined);
        this.vvvoCtrl.markAsTouched();
    }

    allesAn() {
        this.modulBelege = true;
        this.modulTierbewegung = true;
        this.modulBio = true;
    }

    speichern() {
        if (this.isEdit) {
            this.freigabeAktualisieren();
            return;
        }
        this.freigabeErteilen();
    }

    freigabeErteilen() {
        if (this.vvvoCtrl.valid && this.kunde) {
            const freigabe = new Freigabe();
            freigabe.kunde_id = this.kunde?.kunde_id;
            freigabe.vvvo_freigabe = this.vvvoCtrl.value;
            Object.assign(freigabe, this.flagsPayload());

            this.api.post(this.apiBaseUrl + 'kunde_freigabe/create.php', freigabe).subscribe({
                next: () => {
                    this.messageService.infoMessage('Die Freigabe wurde erteilt!');
                    this.dialogRef.close(true);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler', err);
                },
            });
        }
    }

    private freigabeAktualisieren() {
        const payload = {
            kf_id: this.editFreigabe.kf_id,
            ...this.flagsPayload(),
        };
        this.api.post(this.apiBaseUrl + 'kunde_freigabe/update.php', payload).subscribe({
            next: () => {
                this.messageService.infoMessage('Die Freigabe wurde gespeichert!');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler', err);
            },
        });
    }

    private flagsPayload(): { modul_belege: number; modul_tierbewegung: number; modul_bio: number } {
        return {
            modul_belege: this.modulBelege ? 1 : 0,
            modul_tierbewegung: this.modulTierbewegung ? 1 : 0,
            modul_bio: this.modulBio ? 1 : 0,
        };
    }
}
